
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.667 3.359H3.333c-.916 0-1.658.75-1.658 1.666l-.008 10c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667v-10c0-.916-.75-1.666-1.666-1.666zM3.333 7.525h8.75v2.917h-8.75V7.525zm0 4.584h8.75v2.916H4.167a.836.836 0 01-.834-.833v-2.083zm12.5 2.916H13.75v-7.5h2.917v6.667a.836.836 0 01-.834.833z","fill":"#fff"}})])
          )
        }
      }
    